import { type AppThunk } from "../../../index";
import { logOutFailed, logOutStarted, logOutSuccess } from "../reducer";
import { unsubscribeFromUserProfile } from "./unsubscribeFromUserProfile";

export const logOutUser =
  (callback?: () => void): AppThunk =>
  async (dispatch, getState, { auth, analytics, subscriptions }) => {
    dispatch(logOutStarted());
    try {
      // await dispatch(setUserPresence(UserActivityStatus.Offline));
      dispatch(unsubscribeFromUserProfile());
      const res = await auth.signOut({ scope: "local" });
      if (res.error) {
        dispatch(logOutFailed(res.error.message));
        return;
      }

      if (subscriptions.realtimePresenceChannel) {
        subscriptions.realtimePresenceChannel();
      }

      dispatch(logOutSuccess());
      callback?.();
      analytics.reset();
    } catch (e) {
      dispatch(logOutFailed("Unknown error"));
    }
  };
